
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActionHandler } from '@app/core/components/actions/action.handler';
import { FecharAction } from './master-fechar-visualizar-usuario.action';

@Injectable()
export class MasterVisualizarUsuarioActions {
    constructor(
        private actionHandler: ActionHandler,
        
            private fecharAction: FecharAction
            
        
    ) {}


    fechar(context): Observable<any> {
        return this.actionHandler.perform(this.fecharAction, context);
    }


}